<script>
export default {
    name: "WhoPrevDepartmentSvg"
}
</script>
<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="149.038" height="66.359" viewBox="0 0 149.038 66.359">
        <g id="Group_904" data-name="Group 904" transform="translate(-885.868 -506.943)">
            <g id="Group_903" data-name="Group 903" transform="translate(885.868 506.943)">
                <text id="previous_department" data-name="previous
department" transform="translate(144.545 9)" font-size="12" font-family="Apertura-Medium, Apertura" font-weight="500" letter-spacing="0.1em"><tspan x="-56.964" y="0">previous</tspan><tspan x="-79.212" y="14">department</tspan></text>
                <g id="Group_902" data-name="Group 902" transform="translate(0 11.807)">
                    <g id="Polygon_6" data-name="Polygon 6" transform="translate(0 54.552) rotate(-90)" fill="none">
                        <path d="M27.276,0,54.552,46.369H0Z" stroke="none"/>
                        <path d="M 27.27608680725098 1.972297668457031 L 1.748409271240234 45.36929702758789 L 52.80376434326172 45.36929702758789 L 27.27608680725098 1.972297668457031 M 27.27608680725098 0 L 54.55217742919922 46.36929702758789 L -3.814697265625e-06 46.36929702758789 L 27.27608680725098 0 Z" stroke="none" fill="#000"/>
                    </g>
                    <path id="Path_278" data-name="Path 278" d="M0,0H147.674" transform="translate(1.364 27.276)" fill="none" stroke="#000" stroke-width="1"/>
                </g>
            </g>
        </g>
    </svg>
</template>
